<template>
  <div class="table-tabs-container">
    <div class="table-tabs-container__left-slot">
      <slot name="left" />
    </div>
    <div class="table-tabs-container__controls">
      <div class="table-tabs">
        <div class="table-tabs__label">
          {{ label }}
        </div>
        <div class="table-tabs__items">
          <HeaderTabItem
            v-for="choice in choices"
            :key="choice.id"
            :active="activeTab === choice.id"
            :tab-id="choice.id"
            :tab-name="choice.name"
            class="table-tabs__item"
            @activate="handleTabChange(choice.id)"
          />
        </div>
      </div>
    </div>
    <div class="table-tabs-container__right-slot">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
  import HeaderTabItem from 'components/Data/TableTabs/HeaderTabItem';

  export default {
    name: 'TableTabs',
    components: {HeaderTabItem},
    props: {
      label: {
        type: String,
        default: ''
      },
      activeTab: {
        type: String,
        required: true
      },
      choices: {
        type: Array,
        required: true
      },
      columns: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        activeTabId: null
      };
    },
    watch: {
      activeTab: {
        immediate: true,
        handler () {
          this.emitFilteredColumns();
        }
      }
    },
    mounted () {
      this.emitFilteredColumns();
    },
    methods: {
      handleTabChange (choiceId) {
        this.$emit('tabChange', choiceId);
      },
      emitFilteredColumns () {
        this.$emit('changeColumns', this.columns.filter(c => this.checkColumnMatch(c)));
      },
      checkColumnMatch (column) {
        const targetTab = column.tab;
        if (!targetTab) {
          return true;
        }
        if (Array.isArray(column.tab)) {
          return column.tab.includes(this.activeTab);
        }
        return column.tab === this.activeTab;
      }
    }
  };
</script>

<style>
  .table-tabs-container {
    display: flex;
  }

  .table-tabs-container__controls {
    flex-shrink: 0;
    margin: 0 auto;
  }

  .table-tabs {
    display: flex;

    justify-content: center;
    align-items: center;
  }

  .table-tabs__label {
    font-size: 14px;
    font-weight: var(--medium-font-weight);

    color: var(--gray-text-color);

    margin-right: 6px;
  }

  /* stylelint-disable plugin/stylelint-group-selectors */
  .table-tabs__items {
    display: flex;
  }

  .table-tabs__item {
    margin: 0 6px;
  }

</style>
